import { List } from "antd";
import { inject, observer } from "mobx-react";
import { Component } from "react";
import { ReleaseItem } from "..";
import styles from "./ReleaseItemList.module.scss";
import { InjectedProps, ReleaseItemListProps } from "./ReleaseItemListModel";

@inject("publishToLiveStore")
@observer
class ReleaseItemList extends Component<ReleaseItemListProps> {
  get injected() {
    return this.props as InjectedProps;
  }
  render() {
    const {
      loaders: { publish, init },
      filteredReleaseItems,
    } = this.injected.publishToLiveStore;
    return (
      <List
        className={styles.ListContainer}
        loading={publish || init}
        itemLayout="horizontal"
        dataSource={filteredReleaseItems}
        renderItem={(item) => <ReleaseItem releaseItem={item} />}
        pagination={{
          defaultCurrent: 1,
          total: filteredReleaseItems.length,
          position: "bottom",
          showSizeChanger: true,
        }}
      />
    );
  }
}

export default ReleaseItemList;
